import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=3f231301&"
import script from "./PerformanceChart.vue?vue&type=script&lang=js&"
export * from "./PerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports